import { Card } from "./Card.js";
import { ScoreMeter } from "./ScoreMeter.js";

interface RealityScoreCardProps {
  realityScore: number;
  signalScore: number;
  noiseScore: number;
  evidenceScore: number;
  noveltyScore: number;
  sourceTrust: number;
  rationale?: string;
}

export function RealityScoreCard({
  realityScore,
  signalScore,
  noiseScore,
  evidenceScore,
  noveltyScore,
  sourceTrust,
  rationale,
}: RealityScoreCardProps) {
  const score100 = realityScore * 100;
  const band =
    score100 >= 80
      ? { label: "Real activity", color: "var(--bios-signal)" }
      : score100 >= 50
      ? { label: "Mixed", color: "var(--bios-mixed)" }
      : { label: "Mostly narrative", color: "var(--bios-noise)" };
  return (
    <Card title="Reality Score">
      <p style={{ margin: "0 0 10px", fontSize: 12, color: "var(--bios-text-muted)" }}>
        How much of this activity is real vs narrative-driven.
      </p>
      <div style={{ display: "flex", alignItems: "baseline", gap: 12, marginBottom: 6 }}>
        <span className="bios-stat-value" style={{ color: band.color }}>{score100.toFixed(0)}</span>
        <span style={{ fontSize: 13, color: "var(--bios-text-muted)" }}>/ 100</span>
        <span style={{ marginLeft: "auto", fontSize: 12, color: band.color, fontWeight: 500 }}>{band.label}</span>
      </div>
      <div style={{ fontSize: 11, color: "var(--bios-text-faint)", marginBottom: 14, fontFamily: "var(--bios-mono)" }}>
        80–100 real · 50–79 mixed · 0–49 narrative
      </div>
      <div style={{ display: "grid", gap: 10 }}>
        <Row label="Signal" value={signalScore} />
        <Row label="Evidence" value={evidenceScore} />
        <Row label="Novelty" value={noveltyScore} />
        <Row label="Source trust" value={sourceTrust} />
        <Row label="Noise" value={noiseScore} inverse />
      </div>
      {rationale && (
        <div style={{ marginTop: 14, fontFamily: "var(--bios-mono)", fontSize: 11, color: "var(--bios-text-faint)", lineHeight: 1.6 }}>
          {rationale}
        </div>
      )}
    </Card>
  );
}

function Row({ label, value, inverse }: { label: string; value: number; inverse?: boolean }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "110px 1fr", alignItems: "center", gap: 12 }}>
      <span style={{ fontSize: 12, color: inverse ? "var(--bios-noise)" : "var(--bios-text-muted)" }}>{label}</span>
      <ScoreMeter value={value} />
    </div>
  );
}
